import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";
import { Transfer } from "../../../../types";

import styles from "./CreatedByRenderer.module.scss";

interface Props extends ICellRendererParams {
  data: Transfer;
}

const CreatedByRenderer = ({ data }: Props) => {
  return (
    <div className={styles.createdBlock}>
      <div className={styles.line}>
        <div className={styles.displayName}>{data?.createdBy}</div>
      </div>
    </div>
  );
};

export default CreatedByRenderer;
